function getFocusableElements(e) {
  return Array.from(
    e.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}
class SectionId {
  static #e = "__";
  static parseId(e) {
    return e.split(SectionId.#e)[0];
  }
  static parseSectionName(e) {
    return e.split(SectionId.#e)[1];
  }
  static getIdForSection(e, t) {
    return `${e}${SectionId.#e}${t}`;
  }
}
class HTMLUpdateUtility {
  static viewTransition(e, t, r = [], n = []) {
    r?.forEach((e) => e(t));
    const o = document.createElement("div");
    HTMLUpdateUtility.setInnerHTML(o, t.outerHTML);
    const s = o.firstChild,
      a = Date.now();
    e.querySelectorAll("[id], [form]").forEach((e) => {
      e.id && (e.id = `${e.id}-${a}`),
        e.form && e.setAttribute("form", `${e.form.getAttribute("id")}-${a}`);
    }),
      e.parentNode.insertBefore(s, e),
      (e.style.display = "none"),
      n?.forEach((e) => e(s)),
      setTimeout(() => e.remove(), 500);
  }
  static setInnerHTML(e, t) {
    (e.innerHTML = t),
      e.querySelectorAll("script").forEach((e) => {
        const t = document.createElement("script");
        Array.from(e.attributes).forEach((e) => {
          t.setAttribute(e.name, e.value);
        }),
          t.appendChild(document.createTextNode(e.innerHTML)),
          e.parentNode.replaceChild(t, e);
      });
  }
}
document.querySelectorAll('[id^="Details-"] summary').forEach((e) => {
  e.setAttribute("role", "button"),
    e.setAttribute("aria-expanded", e.parentNode.hasAttribute("open")),
    e.nextElementSibling.getAttribute("id") &&
      e.setAttribute("aria-controls", e.nextElementSibling.id),
    e.addEventListener("click", (e) => {
      e.currentTarget.setAttribute(
        "aria-expanded",
        !e.currentTarget.closest("details").hasAttribute("open")
      );
    }),
    e.closest("header-drawer, menu-drawer") ||
      e.parentElement.addEventListener("keyup", onKeyUpEscape);
}),
  document.querySelectorAll('[id^="Details-"] summary').forEach((e) => {
    e.setAttribute("role", "button"),
      e.setAttribute("aria-expanded", e.parentNode.hasAttribute("open")),
      e.nextElementSibling.getAttribute("id") &&
        e.setAttribute("aria-controls", e.nextElementSibling.id),
      e.addEventListener("click", (e) => {
        e.currentTarget.setAttribute(
          "aria-expanded",
          !e.currentTarget.closest("details").hasAttribute("open")
        );
      }),
      e.closest("header-drawer, menu-drawer") ||
        e.parentElement.addEventListener("keyup", onKeyUpEscape);
  });
const trapFocusHandlers = {};
function trapFocus(e, t = e) {
  var r = getFocusableElements(e),
    n = r[0],
    o = r[r.length - 1];
  removeTrapFocus(),
    (trapFocusHandlers.focusin = (t) => {
      (t.target !== e && t.target !== o && t.target !== n) ||
        document.addEventListener("keydown", trapFocusHandlers.keydown);
    }),
    (trapFocusHandlers.focusout = function () {
      document.removeEventListener("keydown", trapFocusHandlers.keydown);
    }),
    (trapFocusHandlers.keydown = function (t) {
      "TAB" === t.code.toUpperCase() &&
        (t.target !== o || t.shiftKey || (t.preventDefault(), n.focus()),
        (t.target !== e && t.target !== n) || !t.shiftKey || (t.preventDefault(), o.focus()));
    }),
    document.addEventListener("focusout", trapFocusHandlers.focusout),
    document.addEventListener("focusin", trapFocusHandlers.focusin),
    t.focus(),
    "INPUT" === t.tagName &&
      ["search", "text", "email", "url"].includes(t.type) &&
      t.value &&
      t.setSelectionRange(0, t.value.length);
}
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}
function focusVisiblePolyfill() {
  const e = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let t = null,
    r = null;
  window.addEventListener("keydown", (t) => {
    e.includes(t.code.toUpperCase()) && (r = !1);
  }),
    window.addEventListener("mousedown", (e) => {
      r = !0;
    }),
    window.addEventListener(
      "focus",
      () => {
        t && t.classList.remove("focused"),
          r || ((t = document.activeElement), t.classList.add("focused"));
      },
      !0
    );
}
function removeTrapFocus(e = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin),
    document.removeEventListener("focusout", trapFocusHandlers.focusout),
    document.removeEventListener("keydown", trapFocusHandlers.keydown),
    e && e.focus();
}
function onKeyUpEscape(e) {
  if ("ESCAPE" !== e.code.toUpperCase()) return;
  const t = e.target.closest("details[open]");
  if (!t) return;
  const r = t.querySelector("summary");
  t.removeAttribute("open"), r.setAttribute("aria-expanded", !1), r.focus();
}
function getFocusableElements(e) {
  return Array.from(
    e.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}
function debounce(e, t) {
  let r;
  return (...n) => {
    clearTimeout(r), (r = setTimeout(() => e.apply(this, n), t));
  };
}
class MenuDrawer extends HTMLElement {
  constructor() {
    super(),
      (this.mainDetailsToggle = this.querySelector("details")),
      this.addEventListener("keyup", this.onKeyUp.bind(this)),
      this.addEventListener("focusout", this.onFocusOut.bind(this)),
      this.bindEvents();
  }
  bindEvents() {
    this.querySelectorAll("summary").forEach((e) =>
      e.addEventListener("click", this.onSummaryClick.bind(this))
    ),
      this.querySelectorAll(
        "button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)"
      ).forEach((e) => e.addEventListener("click", this.onCloseButtonClick.bind(this)));
  }
  onKeyUp(e) {
    if ("ESCAPE" !== e.code.toUpperCase()) return;
    const t = e.target.closest("details[open]");
    t &&
      (t === this.mainDetailsToggle
        ? this.closeMenuDrawer(e, this.mainDetailsToggle.querySelector("summary"))
        : this.closeSubmenu(t));
  }
  onSummaryClick(e) {
    const t = e.currentTarget,
      r = t.parentNode,
      n = r.closest(".has-submenu"),
      o = r.hasAttribute("open"),
      s = window.matchMedia("(prefers-reduced-motion: reduce)");
    function a() {
      trapFocus(t.nextElementSibling, r.querySelector("button")),
        t.nextElementSibling.removeEventListener("transitionend", a);
    }
    r === this.mainDetailsToggle
      ? (o && e.preventDefault(),
        o ? this.closeMenuDrawer(e, t) : this.openMenuDrawer(t),
        window.matchMedia("(max-width: 990px)") &&
          document.documentElement.style.setProperty(
            "--viewport-height",
            `${window.innerHeight}px`
          ))
      : setTimeout(() => {
          r.classList.add("menu-opening"),
            t.setAttribute("aria-expanded", !0),
            n && n.classList.add("submenu-open"),
            !s || s.matches ? a() : t.nextElementSibling.addEventListener("transitionend", a);
        }, 100);
  }
  openMenuDrawer(e) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    }),
      e.setAttribute("aria-expanded", !0),
      trapFocus(this.mainDetailsToggle, e),
      document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
  closeMenuDrawer(e, t = !1) {
    void 0 !== e &&
      (this.mainDetailsToggle.classList.remove("menu-opening"),
      this.mainDetailsToggle.querySelectorAll("details").forEach((e) => {
        e.removeAttribute("open"), e.classList.remove("menu-opening");
      }),
      this.mainDetailsToggle.querySelectorAll(".submenu-open").forEach((e) => {
        e.classList.remove("submenu-open");
      }),
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`),
      removeTrapFocus(t),
      this.closeAnimation(this.mainDetailsToggle),
      e instanceof KeyboardEvent && t?.setAttribute("aria-expanded", !1));
  }
  onFocusOut() {
    setTimeout(() => {
      this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement) &&
        this.closeMenuDrawer();
    });
  }
  onCloseButtonClick(e) {
    const t = e.currentTarget.closest("details");
    this.closeSubmenu(t);
  }
  closeSubmenu(e) {
    const t = e.closest(".submenu-open");
    t && t.classList.remove("submenu-open"),
      e.classList.remove("menu-opening"),
      e.querySelector("summary").setAttribute("aria-expanded", !1),
      removeTrapFocus(e.querySelector("summary")),
      this.closeAnimation(e);
  }
  closeAnimation(e) {
    let t;
    const r = (n) => {
      void 0 === t && (t = n);
      n - t < 400
        ? window.requestAnimationFrame(r)
        : (e.removeAttribute("open"),
          e.closest("details[open]") &&
            trapFocus(e.closest("details[open]"), e.querySelector("summary")));
    };
    window.requestAnimationFrame(r);
  }
}
customElements.define("menu-drawer", MenuDrawer);
class FacetFiltersForm extends HTMLElement {
  constructor() {
    super(),
      (this.onActiveFilterClick = this.onActiveFilterClick.bind(this)),
      (this.debouncedOnSubmit = debounce((e) => {
        this.onSubmitHandler(e);
      }, 800));
    this.calculateFilterHeight();
    this.querySelector("form").addEventListener("input", this.debouncedOnSubmit.bind(this));
    const e = this.querySelector("#FacetsWrapperDesktop");
    e && e.addEventListener("keyup", onKeyUpEscape);
  }
  calculateFilterHeight() {
    const sectionElement = this.closest('.facets-container.col-grid-sidebar').nextElementSibling;
    const filterForm = this.querySelector('#FacetFiltersFormMobile');
    
    if (filterForm && sectionElement) {
      const updateHeight = () => {
        const sectionHeight = sectionElement.clientHeight;
        filterForm.style.height = sectionHeight - 35 + 'px';
      };
      updateHeight();
      const resizeObserver = new ResizeObserver(() => {
        updateHeight();
      });
      resizeObserver.observe(sectionElement);
    }
  }
  static setListeners() {
    window.addEventListener("popstate", (e) => {
      const t = e.state ? e.state.searchParams : FacetFiltersForm.searchParamsInitial;
      t !== FacetFiltersForm.searchParamsPrev && FacetFiltersForm.renderPage(t, null, !1);
    });
  }
  static toggleActiveFacets(e = !0) {
    document.querySelectorAll(".js-facet-remove").forEach((t) => {
      t.classList.toggle("disabled", e);
    });
  }
  static renderPage(e, t, r = !0) {
    FacetFiltersForm.searchParamsPrev = e;
    const n = FacetFiltersForm.getSections(),
      o =
        (document.querySelector(".collection-infinite"),
        document.querySelectorAll(
          ".facets-container .loading__spinner, facet-filters-form .loading__spinner"
        ));
    o.length && o.forEach((e) => e.classList.remove("hidden")),
      n.forEach((r) => {
        const n = `${window.location.pathname}?section_id=${r.section}&${e}`,
          o = (e) => e.url === n;
        FacetFiltersForm.filterData.some(o)
          ? FacetFiltersForm.renderSectionFromCache(o, t)
          : FacetFiltersForm.renderSectionFromFetch(n, t);
      }),
      r && FacetFiltersForm.updateURLHash(e);
  }
  static renderSectionFromFetch(e, t) {
    fetch(e)
      .then((e) => e.text())
      .then((r) => {
        const n = r;
        (FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html: n, url: e }]),
          FacetFiltersForm.renderFilters(n, t),
          FacetFiltersForm.renderProductGridContainer(n);
      });
  }
  static renderSectionFromCache(e, t) {
    const r = FacetFiltersForm.filterData.find(e).html;
    FacetFiltersForm.renderFilters(r, t), FacetFiltersForm.renderProductGridContainer(r);
  }
  static renderProductGridContainer(e) {
    const t = new DOMParser().parseFromString(e, "text/html"),
      r = document.querySelector(".collection-infinite"),
      n = t.querySelector(".collection-infinite");
    r && n && (r.innerHTML = n.innerHTML);
    const o = document.querySelector(".more-products"),
      s = t.querySelector(".more-products");
    o && s && (o.innerHTML = s.innerHTML);
  }
  static renderFilters(e, t) {
    const r = new DOMParser().parseFromString(e, "text/html"),
      n = r.querySelectorAll(
        "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter"
      ),
      o = document.querySelectorAll(
        "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter"
      );
    Array.from(o).forEach((e) => {
      Array.from(n).some(({ id: t }) => e.id === t) || e.remove();
    });
    const s = (e) => {
        const r = t ? t.target.closest(".js-filter") : void 0;
        return !!r && e.id === r.id;
      },
      a = Array.from(n).filter((e) => !s(e)),
      i = Array.from(n).find(s);
    if (
      (a.forEach((e, t) => {
        if (document.getElementById(e.id)) document.getElementById(e.id).innerHTML = e.innerHTML;
        else {
          if (t > 0) {
            const { className: r, id: n } = a[t - 1];
            if (e.className === r) return void document.getElementById(n).after(e);
          }
          e.parentElement && document.querySelector(`#${e.parentElement.id} .js-filter`).before(e);
        }
      }),
      FacetFiltersForm.renderAdditionalElements(r),
      i)
    ) {
      const e = t.target.closest(".js-filter").id;
      if (e) {
        FacetFiltersForm.renderCounts(i, t.target.closest(".js-filter")),
          FacetFiltersForm.renderMobileCounts(i, document.getElementById(e));
        const r = document.getElementById(e),
          n = r.classList.contains("mobile-facets__details")
            ? ".mobile-facets__close-button"
            : ".facets__summary",
          o = r.querySelector(n),
          s = "text" === t.target.getAttribute("type");
        o && !s && o.focus();
      }
    }
  }
  static renderActiveFacets(e) {
    [".active-facets-mobile", ".active-facets-desktop"].forEach((t) => {
      const r = e.querySelector(t);
      r && (document.querySelector(t).innerHTML = r.innerHTML);
    }),
      FacetFiltersForm.toggleActiveFacets(!1);
  }
  static renderAdditionalElements(e) {
    [".mobile-facets__open", ".mobile-facets__count", ".sorting"].forEach((t) => {
      e.querySelector(t) && (document.querySelector(t).innerHTML = e.querySelector(t).innerHTML);
    }),
      document.getElementById("FacetFiltersFormMobile").closest("menu-drawer").bindEvents();
  }
  static renderCounts(e, t) {
    const r = t.querySelector(".facets__summary"),
      n = e.querySelector(".facets__summary");
    n && r && (r.outerHTML = n.outerHTML);
    const o = t.querySelector(".facets__header"),
      s = e.querySelector(".facets__header");
    s && o && (o.outerHTML = s.outerHTML);
    const a = t.querySelector(".facets-wrap"),
      i = e.querySelector(".facets-wrap");
    if (i && a) {
      Boolean(t.querySelector("show-more-button .label-show-more.hidden")) &&
        i
          .querySelectorAll(".facets__item.hidden")
          .forEach((e) => e.classList.replace("hidden", "show-more-item")),
        (a.outerHTML = i.outerHTML);
    }
  }
  static renderMobileCounts(e, t) {
    const r = t.querySelector(".mobile-facets__list"),
      n = e.querySelector(".mobile-facets__list");
    n && r && (r.outerHTML = n.outerHTML);
  }
  static updateURLHash(e) {
    history.pushState({ searchParams: e }, "", `${window.location.pathname}${e && "?".concat(e)}`);
  }
  static getSections() {
    return [{ section: document.querySelector(".Coll-Section").dataset.sectionId }];
  }
  createSearchParams(e) {
    const t = new FormData(e);
    return new URLSearchParams(t).toString();
  }
  onSubmitForm(e, t) {
    FacetFiltersForm.renderPage(e, t);
  }
  onSubmitHandler(e) {
    e.preventDefault();
    const t = document.querySelectorAll("facet-filters-form form");
    if ("mobile-facets__checkbox" == e.srcElement.className) {
      const t = this.createSearchParams(e.target.closest("form"));
      this.onSubmitForm(t, e);
    } else {
      const r = [],
        n = "FacetFiltersFormMobile" === e.target.closest("form").id;
      t.forEach((e) => {
        n
          ? "FacetFiltersFormMobile" === e.id && r.push(this.createSearchParams(e))
          : ("FacetSortForm" !== e.id &&
              "FacetFiltersForm" !== e.id &&
              "FacetSortDrawerForm" !== e.id) ||
            r.push(this.createSearchParams(e));
      }),
        this.onSubmitForm(r.join("&"), e);
    }
  }
  onActiveFilterClick(e) {
    e.preventDefault(), FacetFiltersForm.toggleActiveFacets();
    const t =
      -1 == e.currentTarget.href.indexOf("?")
        ? ""
        : e.currentTarget.href.slice(e.currentTarget.href.indexOf("?") + 1);
    FacetFiltersForm.renderPage(t);
  }
}
(FacetFiltersForm.filterData = []),
  (FacetFiltersForm.searchParamsInitial = window.location.search.slice(1)),
  (FacetFiltersForm.searchParamsPrev = window.location.search.slice(1)),
  customElements.define("facet-filters-form", FacetFiltersForm),
  FacetFiltersForm.setListeners();
class PriceRange extends HTMLElement {
  constructor() {
    super(),
      this.querySelectorAll("input").forEach((e) => {
        e.addEventListener("change", this.onRangeChange.bind(this)),
          e.addEventListener("keydown", this.onKeyDown.bind(this));
      }),
      this.setMinAndMaxValues();
  }
  onRangeChange(e) {
    this.adjustToValidValues(e.currentTarget), this.setMinAndMaxValues();
  }
  onKeyDown(e) {
    if (e.metaKey) return;
    e.key.match(
      /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/
    ) || e.preventDefault();
  }
  setMinAndMaxValues() {
    const e = this.querySelectorAll("input"),
      t = e[0],
      r = e[1];
    r.value && t.setAttribute("data-max", r.value),
      t.value && r.setAttribute("data-min", t.value),
      "" === t.value && r.setAttribute("data-min", 0),
      "" === r.value && t.setAttribute("data-max", r.getAttribute("data-max"));
  }
  adjustToValidValues(e) {
    const t = Number(e.value),
      r = Number(e.getAttribute("data-min")),
      n = Number(e.getAttribute("data-max"));
    t < r && (e.value = r), t > n && (e.value = n);
  }
}
customElements.define("price-range", PriceRange);
class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const e = this.querySelector("a");
    e.setAttribute("role", "button"),
      e.addEventListener("click", this.closeFilter.bind(this)),
      e.addEventListener("keyup", (e) => {
        e.preventDefault(), "SPACE" === e.code.toUpperCase() && this.closeFilter(e);
      });
  }
  closeFilter(e) {
    e.preventDefault();
    (
      this.closest("facet-filters-form") || document.querySelector("facet-filters-form")
    ).onActiveFilterClick(e);
  }
}
customElements.define("facet-remove", FacetRemove);
